module.exports = "\n    .dropdown {\n        position: relative;\n        display: inline-block;\n    }\n\n   "


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles